

<template>
    <div class="ui-navigation">
      <div class="ui-navigation__wrapper">
        <div class="ui-navigation__zoom-icon ui-navigation__zoom-icon--left">
            <svg-icon name="less" />
        </div>
        <div
          class="ui-navigation__line-wrapper"
          ref="line"
          @mousedown="onStart"
          @touchstart="onStart"
        >
          <div class="ui-navigation__line">
            <div class="ui-navigation__fill" :style="{
                flexGrow: zoom
            }"></div>
            <div
              class="ui-navigation__circle"
              :class="{'ui-navigation__circle--focus': focus}"
              :style="{
                    left: `${zoom * 100}%`
                }"
            >
              <div
                class="ui-navigation__inner-circle"
                :class="{'ui-navigation__inner-circle--focus': focus}"
              ></div>
            </div>
          </div>
        </div>
  
        <div class="ui-navigation__zoom-icon ui-navigation__zoom-icon--right">
            <svg-icon name="more" />
        </div>
      </div>
    </div>
  </template>

<script>
export default {
  props: {
    zoom: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      focus: false
    };
  },
  mounted() {
    window.addEventListener("mouseup", this.onStop, { passive: false });
    window.addEventListener("mousemove", this.onDrag, { passive: false });
    window.addEventListener("touchmove", this.onDrag, { passive: false });
    window.addEventListener("touchend", this.onStop, { passive: false });
  },
  destroyed() {
    window.removeEventListener("mouseup", this.onStop);
    window.removeEventListener("mousemove", this.onDrag);
    window.removeEventListener("touchmove", this.onDrag);
    window.removeEventListener("touchend", this.onStop);
  },
  methods: {
    onDrag(e) {
      if (this.focus) {
        const position = e.touches ? e.touches[0].clientX : e.clientX;
        const line = this.$refs.line;

        if (line) {
          const { left, width } = line.getBoundingClientRect();
          this.$emit(
            "change",
            Math.min(1, Math.max(0, position - left) / width)
          );
        }
        if (e.preventDefault) {
          e.preventDefault();
        }
      }
    },
    onStop() {
      this.focus = false;
    },
    onStart(e) {
      this.focus = true;
      this.onDrag(e);
    }
  }
};
</script>


<style lang="scss">
.ui-navigation {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  
  &__wrapper {
    display: flex;
    align-items: center;
    width: 100%;
  }

  &__zoom-icon {
    height: 18px;
    width: 18px;


    svg {
        height: 100%;
        width: 100%;
        display: block;
        fill: var(--dark-blue);
    }
    
    &--left {
      margin-right: 10px;
    }
    &--right {
      margin-left: 10px;
    }
  }
  &__line-wrapper {
    width: 100%;
    height: 1px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
  }
  &__line {
    background: var(--black-100);
    height: 5px;
    width: 100%;
    border-radius: 5px;
    display: flex;
    position: relative;
    align-items: center;
  }
  &__fill {
    background: var(--black-100);
    align-self: stretch;
    flex-basis: auto;
    flex-direction: column;
    flex-shrink: 0;
  }
  &__circle {
    width: 11px;
    height: 11px;
    margin-left: -5px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: background-color, box-shadow;
    background-color: transparent;
    &:hover {
      background-color: var(--dark-blue);
    }
    &--focus {
      background-color: var(--dark-blue);
    }
  }
  &__inner-circle {
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background-color: var(--dark-blue);
    transform: scale(1);
    transition-duration: 0.1s;
    transition-property: transform;
    &--focus {
      transform: scale(1.1);
    }
  }
}
</style>
